// extracted by mini-css-extract-plugin
export default {"fixTip":"HiFollowFixTip_fixTip__Rubxt","tipArea":"HiFollowFixTip_tipArea__s8lrf","tipText":"HiFollowFixTip_tipText__D4djL","followBtn":"HiFollowFixTip_followBtn__8ZAaO"};